/**
 * Global Imports
*/

import React from 'react';

/**
 * Root Imports
*/

import { Router } from '~/components/Router';

/**
 * Local Imports
*/

import { RoleProvider } from '../../Providers';
import { IndexRole, ShowRole } from '../../Views/Roles';

/**
 * Exports
*/

/**
 * 
 */
export function RoleRouter(props) {
  return (
    <Router
      provider={ RoleProvider }
      routes={[
        {
          path: '/:id',
          component: ShowRole
        },
        {
          path: '',
          component: IndexRole
        }
      ]}
    />
  );
}